import React from 'react';
import PropTypes from 'prop-types';

import { __t } from '@mssgme/shared';
import styles from './styles.scss';

export class CardReviewRecommend extends React.Component {
    static propTypes = {
        fullName: PropTypes.string.isRequired,
        onRecommend: PropTypes.func,
    };

    constructor(props) {
        super(props);

        this.state = {
            fbLoggedIn: false,
            fbUserHasComment: false,
        };
    }

    handleClick(value, e) {
        e.preventDefault();

        const { onRecommend } = this.props;
        onRecommend && onRecommend(value);
    }

    render() {
        const { fullName } = this.props;

        return (
            <div className={styles.root}>
                <span className={styles.heading}>{__t('reviews_recommend', [fullName])}</span>
                <div className={styles.buttonsContainer}>
                    <span onClick={this.handleClick.bind(this, true)} className={styles.button} data-recommend>
                        {__t('yes')}
                    </span>
                    <span onClick={this.handleClick.bind(this, false)} className={styles.button} data-recommend={false}>
                        {__t('no')}
                    </span>
                </div>
            </div>
        );
    }
}
